import * as React from 'react';
import './signature-button.css';
import clsx from 'clsx';

interface SignatureButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
}

const SignatureButton = React.forwardRef<
  HTMLButtonElement,
  SignatureButtonProps
>(({ onClick, children, icon, className, ...props }, ref) => {
  const containerClasses = clsx('sb__container', className);

  return (
    <button
      type="button"
      ref={ref}
      onClick={onClick}
      className={containerClasses}
      {...props}
    >
      <div className="sb__icon">{icon}</div>
      {children}
    </button>
  );
});

export { SignatureButton };
